import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import SiteMenu from 'client/components/site-menu';
import React, { Component } from 'react';

import { CommonData, LangSwitcherItem, MenuListItem, ServiceItem } from 'client/bundles/types';
import LangSwitcher from 'client/components/lang-switcher';

import 'client/components/nav/index.css';
import './index.css';

const b = cn('header');
const bNav = cn('nav');

interface Props {
    items: MenuListItem[];
    services: ServiceItem[];
    langSwitcher: LangSwitcherItem[];
    common: CommonData;
    isTestingEnv: boolean;
    isMenuOpened: boolean;
    onNavToggled: (opened: boolean) => void;
}

class Header extends Component<Props> {
    static contextType = LangContext;

    toggleMenu = () => {
        this.props.onNavToggled(!this.props.isMenuOpened);
    }

    renderSiteMenu = () => {
        return <SiteMenu items={this.props.items} />;

    }

    renderAllServices = () => {
        const { services } = this.props;

        return (services.map((service: ServiceItem) => {
            return this.renderServiceLink(service);
        }));
    }

    renderServiceLink = ({ id, href, title, isCurrent }: ServiceItem) => {
        return (
            <a href={href} key={id} className={b('service', { active: isCurrent })}>
                {title}
            </a>
        );
    }

    renderServicesMenu = () => {
        return (
            <nav className={b('navigation')}>
                {this.renderAllServices()}
            </nav>);
    }

    renderHeader = () => {
        const { langSwitcher, common } = this.props;
        const { lang } = this.context;

        return (
            <div className={b()}>
                {
                    this.props.isTestingEnv &&
                    <div className={b('testing-line')}>{lang === 'en' ? 'Testing version' : 'Тестовая версия'}</div>
                }
                <header className={b('main')}>
                    <div className={b('logo', { lang })}>
                        <a className={b('logo-link')} href={common.yandexMainPageUrl}>{common.yandexMainPageTitle}</a>
                    </div>

                    <div className={b('services')}>
                        {this.renderServicesMenu()}
                    </div>

                    <div className={b('lang-switcher')}>
                        <LangSwitcher langs={langSwitcher} isShow={common.isLangSwitcherShow} />
                    </div>

                    <div className={b('nav')} onClick={this.toggleMenu} />
                </header>
                {this.renderSiteMenu()}
            </div>
        );
    }

    renderNav = () => {
        const { langSwitcher, common } = this.props;

        return (
            <div className={bNav({ opened: this.props.isMenuOpened })}>
                <div className={bNav('pannel')}>
                    <div className={bNav('close')} onClick={this.toggleMenu} />

                    <div className={bNav('inner')}>
                        <div className={bNav('site-menu')}>
                            {this.renderSiteMenu()}
                        </div>

                        <div className={bNav('lang')}>
                            <LangSwitcher langs={langSwitcher} isShow={common.isLangSwitcherShow} />
                        </div>

                        <div className={bNav('services-wrap')}>
                            <div className={bNav('services-scroller')}>
                                <header className={bNav('services')}>
                                    {this.renderServicesMenu()}
                                </header>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                {this.renderHeader()}

                {this.renderNav()}
            </>
        );
    }
}

export default Header;
